module.exports = __webpack_public_path__ + "img/about-m-slide-14.111eb026.jpg";